package top.wcpe.allincore.ui.runtime.ir.request

import top.wcpe.allincore.ui.runtime.internal.concurrent.AtomicLongCounter
import top.wcpe.allincore.ui.runtime.internal.concurrent.ConcurrentMutableMap
import top.wcpe.allincore.ui.runtime.ir.eval.EvalContext
import kotlin.concurrent.Volatile

/** 请求注册表：维护「已发出但尚未回包」的 PendingRequest 集合。 */
class RequestRegistry {
    private val seq = AtomicLongCounter(0L)
    private val pending = ConcurrentMutableMap<String, PendingRequest>()

    @Volatile private var baseEvalContext: EvalContext? = null

    fun nextId(): String = "req-" + seq.incrementAndGet()
    fun attachEvalContext(ctx: EvalContext) {
        this.baseEvalContext = ctx
    }
    fun register(req: PendingRequest): String {
        pending[req.requestId] = req
        return req.requestId
    }
    fun take(requestId: String): PendingRequest? = pending.remove(requestId)
    fun size(): Int = pending.size()
    fun cancelAll() {
        pending.clear()
    }

    fun tickTimeouts(nowMs: Long) {
        val ctx = baseEvalContext ?: return
        tickTimeouts(nowMs, ctx)
    }

    fun tickTimeouts(nowMs: Long, baseCtx: EvalContext) {
        var expired: MutableList<String>? = null
        for ((key, value) in pending.entriesSnapshot()) {
            if (nowMs >= value.deadline) {
                if (expired == null) expired = mutableListOf()
                expired.add(key)
            }
        }
        expired?.forEach { RequestCallbacks.deliverTimeout(this, it, baseCtx) }
    }
}
